/* --------------------------------------------------------------------------
	Filtered List
-------------------------------------------------------------------------- */

/* globals jQuery, Site */

(function ($, Site) {
	function init() {
		if (!$('.js-filterset').length) {
			return;
		}

		$('.js-filterset-form').on('submit', onFormSubmit);
		$('.js-filterset-category-1').addClass('active');
	}

	function onFormSubmit(e) {
		e.preventDefault();

		var $component = $(this).closest('.js-filterset');
		var selector = $component.find(':selected').data('class');

		$component.find('.js-filterset-category').removeClass('active');
		$component.find(selector).addClass('active').focus();
	}

	Site.OnInit.push(init);
})(jQuery, Site);
